import { useState } from "react";
import { InputBox } from "../Inputs/InputBox";

function Slider(props) {
  const [value, setValue] = useState(props.value);

  function onSliderChange(event) {
    setValue(event.target.value);

    if (typeof props.onChange === "function") props.onChange(event);
  }

  return (
    <div className="slider">
      <div>{props.title}</div>
      <div className={props.editable ? "slider__range--visible" : "slider__range--invisible"}>
        <input
          type={"range"}
          id={props.id}
          step={props.step}
          min={props.min}
          max={props.max}
          value={props.editable ? value : props.value}
          onChange={onSliderChange.bind(this)} />
      </div>
      <div name="inputBox">
        <InputBox
          title={props.inputTitle}
          id={props.id + "Input"}
          fatherId = {props.id}
          step={props.step}
          min={props.min}
          max={props.max}
          unit={props.unit}
          decimalPlaces={0}
          editable={props.editable}
          value={props.editable ? value : props.value}
          onChange={onSliderChange.bind(this)} />
      </div>
    </div>
  );
}

export default Slider;